<template>
	<div v-if="testingDocumentsForm" class="py-8 flex flex-col 2xl:flex-row gap-8 justify-stretch 2xl:items-start">
		<div
        class="flex-1"
        v-if="this.$auth.hasPermission('create:end-of-line-testing-documents')"
    >
			<EndOfLineTestingDocumentsForm
					:form="testingDocumentsForm"
					@on-save="saveEndOfLineTestingDocument"
					:selected-device="$attrs.device"
			/>
		</div>

		<div class="flex-1">
			<EndOfLineTestingDocumentsList
					:selected-device="$attrs.device"
					@on-delete="deleteEndOfLineTestingDocument"
					@on-download="downloadEndOfLineTestingDocument"
			/>
		</div>
	</div>
</template>

<script>
import { mapStores } from "pinia";
import { useEndOfLineTestingDocumentsStore } from "@/stores/endOfLineTestingDocument.js";
import EndOfLineTestingDocumentsForm from "@/Forms/Device/EndOfLineTestingDocument/EndOfLineTestingDocumentsForm.vue";
import EndOfLineTestingDocumentsList from "@/Forms/Device/EndOfLineTestingDocument/EndOfLineTestingDocumentsList.vue";
import { useDownloadLink } from "@/Composables/DownloadLink.js";

export default {
	name: "EndOfLineTestingDocumentsView",
	components: {EndOfLineTestingDocumentsList, EndOfLineTestingDocumentsForm},
	data() {
		return {
			testingDocumentsForm: undefined,
		}
	},
	computed: {
		...mapStores(useEndOfLineTestingDocumentsStore)
	},
	methods: {
		async saveEndOfLineTestingDocument() {
			try {
				const response = await this.testingDocumentsForm.submit();
				this.testingDocumentsForm.reset();
				this.$emit('on-save');
			} catch (error) {
				//
			}
		},
		async deleteEndOfLineTestingDocument(endOfLineTestingDocument) {
			if (endOfLineTestingDocument) {
				await this.endOfLineTestingDocumentsStore.deleteEndOfLineTestingDocument(endOfLineTestingDocument.id);
				this.$emit('on-save');
			}
		},
		async downloadEndOfLineTestingDocument(endOfLineTestingDocument) {
			if (endOfLineTestingDocument) {
				try {
					const response = await this.endOfLineTestingDocumentsStore.showEndOfLineTestingDocument(endOfLineTestingDocument.id, { download: 1 });
					useDownloadLink(response.url);
				} catch (error) {
					console.log('Error downloading end of line testing document', error);
				}
			}
		},
	},
	watch: {
		'$route.params.device': {
			async handler(newValue, oldValue) {
				if (newValue) {
					this.testingDocumentsForm = await this.endOfLineTestingDocumentsStore.createEndOfLineTestingDocument();
					this.testingDocumentsForm.device_id = this.$attrs.device.id;
				} else {
					this.testingDocumentsForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>